
import React, {useState,useRef} from 'react';
import './index.less';
import { QrCode } from 'gyyx-component-lib';
import { qrUnSelfApi} from '@/constants/api';

interface Props {
  setStep: React.Dispatch<React.SetStateAction<number>>;
  uuid: string;
}

const StepSecond = (props: Props) =>  {
  const qrRef = useRef<any>(null);
  const [submitErrorVal, setSubmitErrorVal] = useState('');

  const setQrCodeStatus = (qrState: string) => {

    if (qrState === 'qrcode_scan') {
      const guild = qrRef.current.qrCode.split('?t=WL')[0].split('gyc://gyyx.cn/')[1] as string;
      qrUnSelfApi({guidId: guild, uuid: props.uuid}).then(r => {
        if (r.retCode !== 'SUCCESS') {
          setSubmitErrorVal(r.message);
          return;
        }
        props.setStep(2);
      }).catch(error => {
        console.log(error);
        setSubmitErrorVal("响应异常，请稍后重试");
      });
    }
  };

  return (
    <div className='stepSecondBox'>
      <div className="qr_code_box">
        <div className="submit_error" style={{ display: submitErrorVal ? 'block' : 'none' }}>
            <div className="error_val">
              {submitErrorVal}
            </div>
        </div>
        <div className="qr_code_verify">
          <div className='ewmSize'>
            <QrCode ref={qrRef} bizType={'WG-GJF'} setQrCodeStatus={setQrCodeStatus}/>
          </div>
          <p className='ewmSizeP'>请用WEGAME版光宇APP扫码验证</p>
        </div>
        <div className="qr_code_download">
          <img src="//img.gyyxcdn.cn/kf/images/gyewm02.png" />
          <p>如需下载请扫一扫此二维码</p>
        </div>
      </div>
    </div>
  );
};

export default StepSecond;
